import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { v4 as uuidv4 } from 'uuid';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import { Button, Table, Form } from 'react-bootstrap';
import axios from './axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { set } from 'rsuite/esm/internals/utils/date';
import './Functions/manage_orders.css';
import { useNavigate } from 'react-router-dom';
import { notify } from './notify';

const handlePagination = (page, totalPages, setCurrentPage)  => {
    if (page < 1 || page > totalPages) {
      return;
    }
    setCurrentPage(page);
};


const renderPagination = ({ totalPages, currentPage, setCurrentPage}) => {
    if (totalPages >= 8) {
        return null; // No need for advanced pagination if there are 5 or fewer pages
    }
    const items = [];
    items.push(<Pagination.Prev key={uuidv4()} onClick={() => handlePagination(Number(currentPage) - 1, totalPages, setCurrentPage)} disabled={currentPage === 1}/>)

    for (let number = 1; number <= totalPages; number++) {
    items.push(
        <Pagination.Item key={uuidv4()} active={number === Number(currentPage)} onClick={() => handlePagination(number, totalPages, setCurrentPage)}>
        {number}
        </Pagination.Item>
    );
    }

    items.push(<Pagination.Next key={uuidv4()} onClick={() => handlePagination(Number(currentPage) + 1, totalPages, setCurrentPage)} disabled={Number(currentPage)== Number(totalPages)} />)

    return <Pagination size="sm">{items}</Pagination>;
};

const renderTableData = (currentPage,data, ...fields) => {
    return data.map((entry, index) => (
        <tr key={uuidv4()}>
            <td>{(currentPage-1)*20+index+1}</td>
            {fields.map((field, i) => (
                <td key={uuidv4()}>{entry[field]}</td>
            ))}
        </tr>
    ));
};

const PartyTable = ({ currentPage, data, handleDeleteParty, fields }) => {
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedParty, setSelectedParty] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [partyData, setPartyData] = useState(null);

    const openDeleteModal = (entry) => {
        setSelectedParty(entry);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedParty(null);
    };

    const confirmDelete = () => {
        handleDeleteParty(selectedParty);
        closeDeleteModal();
    };

    const handleView = async (partyID) => {
        try {
            const response = await axios.get(`${window.backendUrl}/get_party_info/${partyID}`);
            setPartyData(response.data);
            setIsViewModalOpen(true);
        } catch (error) {
            console.error('Error fetching party data:', error);
        }
    };

    const closeViewModal = () => {
        setIsViewModalOpen(false);
        setPartyData(null);
    };


    const handlePartyEditClick = (partyId) => {
      navigate('/add-new-party', { state: {partyId } });
    };

    return (
        <>
            {data.map((entry, index) => (
                <tr key={entry['PartyID'] ?? index}>
                    <td>{(currentPage - 1) * 20 + index + 1}</td>
                    {fields.map((field) => (
                        <td key={field}>{entry[field]}</td>
                    ))}
                    <td style={{textAlign:'center', whiteSpace:'nowrap'}}>
                        <i className="fa fa-info-circle" title="View party" role="button" onClick={() => handleView(entry['PartyID'])} style={{ fontSize: '17px', marginRight: '16px', cursor: 'pointer', color: '#2f5bea' }}></i>
                        <i className="fa fa-edit" id="edit_icon_party" title="Edit party" role="button" style={{ fontSize: '17px', marginRight: '16px', cursor: 'pointer' }} onClick={() => handlePartyEditClick(entry['PartyID'])}></i>
                        <i className="fa fa-trash-o" title="Delete party" role="button" onClick={() => openDeleteModal(entry)} style={{ fontSize: '17px', cursor: 'pointer' }}></i>
                    </td>
                </tr>
            ))}

            <Modal show={isDeleteModalOpen} onHide={closeDeleteModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{margin:0}}>Are you sure you want to delete <strong>{selectedParty?.PartyName}</strong>? This can't be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDeleteModal}>Cancel</Button>
                    <Button variant="danger" onClick={confirmDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={isViewModalOpen} onHide={closeViewModal} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Party Information</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {partyData ? (
                        <>
                            <Table bordered>
                                <tbody>
                                    <tr>
                                        <td><strong>Name:</strong></td>
                                        <td>{partyData.PartyName}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Contact No.:</strong></td>
                                        <td>{partyData.ContactNo}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Address:</strong></td>
                                        <td>{partyData.Address}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Team:</strong></td>
                                        <td>{partyData.TeamName}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Currency:</strong></td>
                                        <td>{partyData.Currency}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Payment Type:</strong></td>
                                        <td>{partyData.PaymentType}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Allowance:</strong></td>
                                        <td>
                                            L+W: {partyData.AllowanceLW}, W+H: {partyData.AllowanceWH}, Length: {partyData.AllowanceLength}, Width: {partyData.AllowanceWidth}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Tally Name - Bill:</strong></td>
                                        <td>{partyData.BillTallyName}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Tally Name - PI (Miah &amp; Sons Ind. Ltd.):</strong></td>
                                        <td>{partyData.PiTallyName}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Notes:</strong></td>
                                        <td>{partyData.Notes}</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <h5>Items</h5>
                            {partyData.items.map(item => (
                                <div key={item.PartyItemID} style={{ marginBottom: '20px' }}>
                                    <h6>{item.ItemName}</h6>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>Specification</th>
                                                <th>Grade</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.specifications.map((spec, specIndex) => (
                                                spec.grades.map((grade, gradeIndex) => (
                                                    <tr key={grade.PartyGradeID}>
                                                        {gradeIndex === 0 && (
                                                            <td rowSpan={spec.grades.length}>{spec.Specification}</td>
                                                        )}
                                                        <td>{grade.Grade}</td>
                                                        <td>{grade.Price}</td>
                                                    </tr>
                                                ))
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            ))}
                        </>
                    ) : (
                        <p>Loading...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeViewModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PartyTable;

const renderTableData2 = (currentPage, data, onCellClick, ...fields) => {
    return data.map((entry, index) => (
        <tr key={uuidv4()}>
                <td key={uuidv4()} onClick={() => onCellClick(entry)} style={{ cursor: 'pointer' }}>
                    <span style={{ textDecoration: 'none', transition: 'text-decoration 0.2s' }} onMouseOver={(e) => e.target.style.textDecoration = 'underline'} onMouseOut={(e) => e.target.style.textDecoration = 'none'}>
                        {(currentPage - 1) * 20 + index + 1}
                    </span>
                </td>
            {fields.map((field, i) => (
                <td key={uuidv4()} onClick={() => onCellClick(entry)} style={{ cursor: 'pointer' }}>
                    <span style={{ textDecoration: 'none', transition: 'text-decoration 0.2s' }} onMouseOver={(e) => e.target.style.textDecoration = 'underline'} onMouseOut={(e) => e.target.style.textDecoration = 'none'}>
                        {entry[field]}
                    </span>
                </td>
            ))}
        </tr>
    ));
};

const renderAdvancedPagination=({ totalPages, currentPage, setCurrentPage })=>{
    if(totalPages < 8){
    return null;
    }
    return(
    <Pagination size="sm" style={{ display: 'flex', justifyContent: 'flex-end', position: 'relative' }}>
        <Pagination.Prev  onClick={() => handlePagination(Number(currentPage) - 1,totalPages, setCurrentPage)} disabled={Number(currentPage)== 1}  key="prev"/>
        {(currentPage == 1 || currentPage == 2 || currentPage == totalPages || currentPage == totalPages - 1) && (
            <>
            <Pagination.Item key={uuidv4()} active={1 === Number(currentPage)} onClick={() => handlePagination(1,totalPages, setCurrentPage)}>1</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={2 === Number(currentPage)} onClick={() => handlePagination(2,totalPages, setCurrentPage)}>2</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item key={uuidv4()} active={(totalPages - 1) === Number(currentPage)} onClick={() => handlePagination(totalPages - 1,totalPages, setCurrentPage)}>{totalPages - 1}</Pagination.Item>
            <Pagination.Item style={{marginRight:'16px'}} key={uuidv4()} active={totalPages === Number(currentPage)} onClick={() => handlePagination(totalPages,totalPages, setCurrentPage)}>{totalPages}</Pagination.Item>
            </>
        )}
        {(currentPage == totalPages - 2) && (
            <>
            <Pagination.Item key={uuidv4()} active={1 === Number(currentPage)} onClick={() => handlePagination(1,totalPages, setCurrentPage)}>1</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={2 === Number(currentPage)} onClick={() => handlePagination(2,totalPages, setCurrentPage)}>2</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item key={uuidv4()} active={(totalPages - 2) === Number(currentPage)} onClick={() => handlePagination(totalPages - 2,totalPages, setCurrentPage)}>{totalPages - 2}</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={(totalPages - 1) === Number(currentPage)} onClick={() => handlePagination(totalPages - 1,totalPages, setCurrentPage)}>{totalPages - 1}</Pagination.Item>
            <Pagination.Item style={{marginRight:'16px'}} key={uuidv4()} active={totalPages === Number(currentPage)} onClick={() => handlePagination(totalPages,totalPages, setCurrentPage)}>{totalPages}</Pagination.Item>
            </>
        )}
        {currentPage == 3 && (
            <>
            <Pagination.Item key={uuidv4()} active={1 === Number(currentPage)} onClick={() => handlePagination(1,totalPages, setCurrentPage)}>1</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={2 === Number(currentPage)} onClick={() => handlePagination(2,totalPages, setCurrentPage)}>2</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={3 === Number(currentPage)} onClick={() => handlePagination(3,totalPages, setCurrentPage)}>3</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item key={uuidv4()} active={(totalPages - 1) === Number(currentPage)} onClick={() => handlePagination(totalPages - 1,totalPages, setCurrentPage)}>{totalPages - 1}</Pagination.Item>
            <Pagination.Item style={{marginRight:'16px'}} key={uuidv4()} active={totalPages === Number(currentPage)} onClick={() => handlePagination(totalPages,totalPages, setCurrentPage)}>{totalPages}</Pagination.Item>
            </>
        )}
        {currentPage > 3 && currentPage < totalPages - 2 && (
            <>
            <Pagination.Item key={uuidv4()} active={1 === Number(currentPage)} onClick={() => handlePagination(1,totalPages, setCurrentPage)}>1</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={2 === Number(currentPage)} onClick={() => handlePagination(2,totalPages, setCurrentPage)}>2</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item key={uuidv4()} active={true} onClick={() => handlePagination(currentPage,totalPages, setCurrentPage)}>{currentPage}</Pagination.Item>
            <Pagination.Item key={uuidv4()} active={false} onClick={() => handlePagination(Number(currentPage)+1,totalPages, setCurrentPage)}>{Number(currentPage) + 1}</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item key={uuidv4()} active={(totalPages - 1) === Number(currentPage)} onClick={() => handlePagination(totalPages - 1,totalPages, setCurrentPage)}>{totalPages - 1}</Pagination.Item>
            <Pagination.Item style={{marginRight:'16px'}}key={uuidv4()} active={totalPages === Number(currentPage)} onClick={() => handlePagination(totalPages,totalPages, setCurrentPage)}>{totalPages}</Pagination.Item>
            </>
        )}
        <Pagination.Next style={{ marginLeft:'8px',position: 'absolute', right: 0 }}  onClick={() => handlePagination(Number(currentPage) + 1,totalPages, setCurrentPage)} disabled={Number(currentPage)== Number(totalPages)}  key={uuidv4()}/>
    </Pagination>
    )
}

const JobApprovalModal = ({ order_status, show, handleClose, handleConfirm }) => {
    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {order_status === 'APPROVED' ? 'Are you sure you want to Disapprove this job?' :
             'Are you sure you want to Approve this job?'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
                {order_status === 'APPROVED' ? 'Disapprove' : 'Approve'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const ScheduleDateModal = ({ show, handleClose, handleSave }) => {
    const [date, setDate] = useState('');

    useEffect(() => {
      setDate('');
    },[]);

    const onSave = () => {
      const schedule_date_unix = Math.floor(new Date(date).getTime() / 1000);
      handleSave(schedule_date_unix);
    };

    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="scheduleDate">
              <Form.Label> <h6>Select a date:</h6></Form.Label>
              {/* <Form.Control 
                type="date" 
                onChange={(e) => set_schedule_date(e.target.value)} 
              /> */}
              {/* <Form.Control 
                type="date" 
                onChange={(e) => set_schedule_date(Math.floor(new Date(e.target.value).getTime() / 1000))}
              /> */}
              <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const Add_BM_Modal = ({ show, setShow, handleSave, details }) => {
    const [date, setDate] = useState('');
    const [new_board_making_qty, set_new_board_making_qty] = useState(0);
  
    const onSave = () => {
        const balance = (details.pp_qty || 0) - (details.board_making_qty || 0);
        if (!date) {
            notify.error('Pick the board making date.');
            return;
        }
        if (!(new_board_making_qty > 0)) {
            notify.error('Board making quantity must be more than 0.');
            return;
        }
        if (new_board_making_qty > balance &&
            !window.confirm(`This is ${new_board_making_qty - balance} more than the remaining balance of ${balance}. Save anyway?`)) {
            return;
        }
        const today = new Date();
        const selectedDate = new Date(date + 'T00:00:00+06:00');
        const isToday = selectedDate.toDateString() === today.toDateString();
        const unixDate = isToday ? Math.floor(today.getTime() / 1000) : Math.floor(selectedDate.getTime() / 1000);

        handleSave({ board_making_date: unixDate, new_board_making_qty});
        setShow(false);
    };

    useEffect(() => {
        set_new_board_making_qty(details.pp_qty - details.board_making_qty);
        const formattedDate = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;
        setDate(formattedDate);
    }, [show]);

    // console.log(number)
    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add new board making quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row >
            <Col className='d-flex-col me-2'>
                <h6 style={{textAlign:'right', marginBottom:'20px'}}>PP quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'20px'}}>Board making done quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'40px'}}>Board making date : </h6>
                <h6 style={{textAlign:'right'}}>New board making quantity : </h6>
            </Col>
            <Col className='d-flex-col'>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.pp_qty}</h6>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.board_making_qty}</h6>
                <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{width:'150px',marginBottom:'20px'}}/>
                <Form.Control type="number" min="1" value={new_board_making_qty} style={{ width: '150px' }}
                    onKeyDown={(e) => { if (e.key === 'Enter') onSave(); }}
                    onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        set_new_board_making_qty(isNaN(value) ? 0 : value);
                    }}
                />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const Edit_PP_Qty_Modal = ({ show, setShow, handleSave, details }) => {
    const [updated_pp_qty, set_updated_pp_qty] = useState(0);
  
    const onSave = () => {
        if (updated_pp_qty < 0) {
            notify.error('P.P. quantity cannot be negative.');
            return;
        }
        if (updated_pp_qty < (details.board_making_qty || 0)) {
            notify.error(`P.P. quantity cannot be less than the ${details.board_making_qty} already made.`);
            return;
        }
        if (updated_pp_qty === details.pp_qty) {
            setShow(false);
            return;
        }
        handleSave(updated_pp_qty);
        setShow(false);
    };

    useEffect(() => {
        set_updated_pp_qty(details.pp_qty || 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update production planning quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row >
            <Col className='d-flex-col me-2'>
                <h6 style={{textAlign:'right', marginBottom:'20px'}}>Current PP quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'40px'}}>Updated PP quantity : </h6>
                <h6 style={{textAlign:'right'}}>Board making done quantity : </h6>
            </Col>
            <Col className='d-flex-col'>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.pp_qty}</h6>
                <Form.Control type="number" min={details.board_making_qty || 0} value={updated_pp_qty} style={{ width: '150px', marginBottom:'25px' }}
                    onKeyDown={(e) => { if (e.key === 'Enter') onSave(); }}
                    onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        set_updated_pp_qty(isNaN(value) ? 0 : value);
                    }}
                />
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.board_making_qty}</h6>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const PP_Date_Modal = ({ show, setShow, handleSave, details }) => {
    const [date, setDate] = useState('');
  
    const onSave = () => {
        if (!date){
            notify.error('Pick the new P.P. date.');
            return
        }
        const unixDate=Math.floor(new Date(date).getTime() / 1000);
        handleSave({ updated_pp_date: unixDate, all_pp_ids: details.all_pp_ids });

        setShow(false);
    };

    useEffect(() => {
        setDate('')
    }, [show]);

    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change production planning date</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row >
            <Col className='d-flex-col me-2'>
                <h6 style={{textAlign:'right', marginBottom:'40px'}}>Current PP date : </h6>
                <h6 style={{textAlign:'right'}}>Updated PP date : </h6>
            </Col>
            <Col className='d-flex-col'>
                <h6 style={{textAlign:'left', marginBottom:'40px'}}>{details.pp_date}</h6>
                <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{width:'150px',marginBottom:'20px'}}/>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const BM_Small_Trash_Modal = ({ show, setShow, handleSave, details }) => {

  const onSave = () => {
      handleSave(details.ProductionPlanningId);
      setShow(false);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title><strong>Remove production planning permanently</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <h5>Are you sure you want to undo the <strong>{details.pp_qty - details.board_making_qty}</strong> remaining balance quantity?</h5>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onSave}>
          Remove balance
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const Add_Finishing_Modal = ({ show, setShow, handleSave, details }) => {
    const [date, setDate] = useState('');
    const [new_finishing_qty, set_new_finishing_qty] = useState(0);
  
    const onSave = () => {
        const today = new Date();
        const selectedDate = new Date(date + 'T00:00:00+06:00');
        const isToday = selectedDate.toDateString() === today.toDateString();
        const unixDate = isToday ? Math.floor(today.getTime() / 1000) : Math.floor(selectedDate.getTime() / 1000);

        handleSave({ finishing_date: unixDate, new_finishing_qty});
        setShow(false);
    };

    useEffect(() => {
        set_new_finishing_qty(details.board_making_qty - details.finished_qty);
        const formattedDate = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;
        setDate(formattedDate);
    }, [show]);

    // console.log(number)
    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add new finishing quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row >
            <Col className='d-flex-col me-2'>
                <h6 style={{textAlign:'right', marginBottom:'20px'}}>PP quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'20px'}}>Board making done quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'25px'}}>Finishing done quantity : </h6>
                <h6 style={{textAlign:'right', marginBottom:'40px'}}>Finishing date : </h6>
                <h6 style={{textAlign:'right'}}>New finishing quantity : </h6>
            </Col>
            <Col className='d-flex-col'>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.pp_qty}</h6>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.board_making_qty}</h6>
                <h6 style={{textAlign:'left', marginBottom:'20px'}}>{details.finished_qty}</h6>
                <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{width:'150px',marginBottom:'20px'}}/>
                <Form.Control type="number" value={new_finishing_qty} style={{ width: '150px' }}
                    onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        set_new_finishing_qty(isNaN(value) ? 0 : value);
                    }}
                />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const Gate_Pass_Date_Modal = ({ show, setShow, handleSave, details }) => {
  const [date, setDate] = useState('');

  const onSave = () => {
      if (!date){
          return
      }
      const unixDate=Math.floor(new Date(date).getTime() / 1000);
      handleSave({ updated_gate_pass_date: unixDate, gate_pass_id: details.gate_pass_id });
      setShow(false);
  };

  useEffect(() => {
      setDate('')
  }, [show]);

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title><strong>Change Date</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <Row >
          <Col className='d-flex-col me-2'>
              <h6 style={{textAlign:'right', marginBottom:'40px'}}>Current date : </h6>
              <h6 style={{textAlign:'right'}}>Updated date : </h6>
          </Col>
          <Col className='d-flex-col'>
              <h6 style={{textAlign:'left', marginBottom:'40px'}}>{new Date(details.gate_pass_date * 1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Asia/Dhaka' }).replace(/\//g, '.')}</h6>
              <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{width:'150px',marginBottom:'20px'}}/>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Gate_Pass_Delete_Modal = ({ show, setShow, handleDelete, details }) => {

  const onDelete = () => {
      handleDelete({gate_pass_id: details.gate_pass_id});
      setShow(false);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title><strong>Remove Gate Pass Permanently</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <Row >
          <Col className='d-flex-col me-2'>
              <h6>Are you sure you want to remove this gate pass ?</h6>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={onDelete}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Gate_Pass_Status_Modal = ({ show, setShow, handleSave, details }) => {
  const title= details.current_status == 0 ? 'Received by Factory' : 'Received by Office' ;
  const new_status = details.current_status == 0 ? 1 : 2;

  const onSave = () => {
      const unixDate = Math.floor(new Date().getTime() / 1000);
      handleSave({ status_modification_date: unixDate, gate_pass_list_id: details.gate_pass_list_id, new_status});
      setShow(false);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title><strong>{title}</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <Row >
          <Col className='d-flex-col me-2'>
              <h6>Are you sure you received this challan ?</h6>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const New_Gate_Pass_Modal = ({ show, setShow, handleSave}) => {
  
    const [vehicle_no, set_vehicle_no] = useState('');
    const [driver_name, set_driver_name] = useState('');

    const onSave = () => {
        handleSave({vehicle_no, driver_name});
        setShow(false);
    };

    useEffect(() => {
        set_vehicle_no('');
        set_driver_name('');
    }, [show]);

    // console.log(number)
    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Gate Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row >
            <Col className='d-flex-col me-2'>
                <h5 style={{textAlign:'right', marginBottom:'40px', fontWeight:'bold'}}>Vehicle No. : </h5>
                <h5 style={{textAlign:'right', marginBottom:'20px', fontWeight:'bold'}}>Driver Name : </h5>
            </Col>
            <Col className='d-flex-col'>
                <Form.Control type="text" value={vehicle_no} onChange={(e) => set_vehicle_no(e.target.value)} style={{width:'300px',marginBottom:'20px'}}/>
                <Form.Control type="text" value={driver_name} onChange={(e) => set_driver_name(e.target.value)} style={{width:'300px',marginBottom:'20px'}}/>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

const Create_Bill_Modal = ({ show, setShow, handleSave }) => {
  const [bill_no, set_bill_no] = useState('');

  const onSave = () => {
    if(!bill_no.trim()){
        alert("Please enter a Bill Number");
        return;
    }
    handleSave(bill_no);
    setShow(false);
  };

  useEffect(() => {
    set_bill_no('');
  }, [show]);

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Bill</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className='d-flex align-items-center justify-content-center'>
              <h5 style={{marginRight: '15px', fontWeight:'bold'}}>Bill No: </h5>
              <Form.Control 
                type="text" 
                value={bill_no} 
                onChange={(e) => set_bill_no(e.target.value)} 
                style={{width:'250px'}}
                placeholder="Enter Bill Number"
              />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Create Bill
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Remove_Bill_Modal = ({ show, setShow, handleRemove, bill }) => {
    return (
        <Modal show={show} onHide={() => setShow(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete Bill <strong>{bill?.billNo}</strong>?</p>
                <p className="text-danger small">
                    This will ungroup the challans. The delivery challans will remain in the system and can be billed again.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => handleRemove(bill?.billId)}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const Edit_Pi_Modal = ({ show, setShow, pi_id }) => {
  const [pi_info, set_pi_info] = useState(null);

  const handleSave = () => {

      axios.post(`${window.backendUrl}/update_pi_info`, pi_info)
        .then((response) => {
            setShow(false);
            window.location.reload()
        })
        .catch((error) => {
            console.log(error);
        });
  };

  useEffect(() => {
      if (show) {
          fetch_pi_info();
      }
  }, [show]);

  const fetch_pi_info = () => {
      axios.get(`${window.backendUrl}/get_pi_info/${pi_id}`)
        .then((response) => {
            set_pi_info(response.data);
        })
        .catch((error) => {
            console.log(error);
        });
  };

  const handleInputChange = (index, field, value) => {
    if (field=='Remarks'){
      value = value || ''
    }else{
      value = parseFloat(value) || 0
    }
    console.log(`Field: ${field}, Value: ${value}`);
    const updatedPiLists = pi_info.pi_lists.map((item, i) => 
      i === index ? { ...item, [field]: value} : item
    );
    set_pi_info({ ...pi_info, pi_lists: updatedPiLists });
  };

  const handleNoteChange = (e) => {
    set_pi_info({ ...pi_info, Note: e.target.value});
  };

  const handlePartyAddressChange = (e) => {
    set_pi_info({ ...pi_info, PartyAddress: e.target.value});
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered className='custom-modal' scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Change PI Information</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{fontSize:'16px',padding:'30px 40px'}}>
        {pi_info && (
          <>
            <Row className="d-flex justify-content-between mb-2 mt-2">
              <Col className='d-flex'>
                <div className='me-4'>
                  <p ><strong>Party Name</strong></p>
                  <p style={{marginBottom:'40px'}}><strong>Party Address</strong></p>
                  <p ><strong>Buyer Name</strong></p>
                  <p><strong>Style</strong></p>
                </div>
                <div className='me-4'>
                  <p >:</p>
                  <p style={{marginBottom:'40px'}}>:</p>
                  <p >:</p>
                  <p >:</p>
                </div>
                <div>
                  <p className='mb-2'>{pi_info.PartyName}</p>
                  <textarea rows='2' style={{width:'270px',marginBottom:'5px'}} value={pi_info.PartyAddress ? pi_info.PartyAddress : ''} onChange={handlePartyAddressChange}/>
                  <p >{pi_info.BuyerName}</p>
                  <p className='mb-2'>{pi_info.Style}</p>
                </div>
              </Col>
              <Col className='d-flex justify-content-end'>
                <div className='me-4'>
                  <p ><strong>Pi No.</strong></p>
                  <p ><strong>Date : </strong></p>
                  <p ><strong>Job Number</strong></p>
                  <p ><strong>LPD No.</strong></p>
                  <p ><strong>Currency</strong></p>
                </div>
                <div className='me-4'>
                  <p>:</p>
                  <p>:</p>
                  <p>:</p>
                  <p>:</p>
                  <p>:</p>
                </div>
                <div>
                  <p >PI/{pi_info.JobNumber}</p>
                  <p>{new Date(pi_info.PiDate * 1000).toLocaleDateString('en-US', { timeZone: 'Asia/Dhaka', year: '2-digit', month: '2-digit', day: '2-digit' }).replace(/\//g, '.')}</p>
                  <p>{pi_info.JobNumber}</p>
                  <p>{pi_info.LpdPoNo || 'N/A'}</p>
                  <p>{pi_info.Currency == 'BDT'? '৳' : '$'}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Item Name</th>
                    <th>Spec.</th>
                    <th>Measurement</th>
                    <th>Quantity</th>
                    <th>Sq. Mt.</th>
                    <th>Net <br/> Weight</th>
                    <th>Unit Price <br/> ($)</th>
                    <th>Addi Work <br/> Price ($)</th>
                    <th>Amount</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {pi_info.pi_lists.map((item, index) => {
                    let totalQuantity = pi_info.pi_lists.reduce((acc, curr) => acc + parseFloat(curr.Quantity), 0).toFixed(2);
                    let totalAmount = pi_info.pi_lists.reduce((acc, curr) => acc + (parseFloat(curr.Quantity) * parseFloat(curr.UnitPrice + curr.AddiPrice)), 0).toFixed(2);


                    return(
                      <>
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.ItemName}</td>
                          <td>{item.Specification}</td>
                          <td>{`${item.Length}x${item.Width}x${item.Height}`}</td>
                          <td>
                            <input
                              type="number"
                              style={{ width: '80px' }}
                              value={item.Quantity}
                              onChange={(e) => handleInputChange(index, 'Quantity', e.target.value)}
                            />
                          </td>
                          <td>{/* Calculation for Sq. Mt. if applicable */}</td>
                          <td>
                            <input
                              type="number"
                              style={{ width: '80px' }}
                              value={item.NetWeight}
                              onChange={(e) => handleInputChange(index, 'NetWeight', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              style={{ width: '80px' }}
                              value={item.UnitPrice}
                              onChange={(e) => handleInputChange(index, 'UnitPrice', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              style={{ width: '80px' }}
                              value={item.AddiPrice}
                              onChange={(e) => handleInputChange(index, 'AddiPrice', e.target.value)}
                            />
                          </td>
                          <td>${(item.Quantity * (item.UnitPrice + item.AddiPrice)).toFixed(2)}</td>
                          <td>
                            <input
                              type="text"
                              style={{ width: '80px' }}
                              value={item.Remarks || ''}
                              onChange={(e) => handleInputChange(index, 'Remarks', e.target.value)}
                            />
                          </td>
                        </tr>
                        {index === pi_info.pi_lists.length - 1 && (
                          <tr>
                            <td colSpan='4' style={{textAlign:'right'}}> <strong>Grand Total : </strong></td>
                            <td><strong>{totalQuantity}</strong></td>
                            <td colSpan='4'></td>
                            <td><strong>${totalAmount}</strong></td>
                            <td></td>
                          </tr>
                        )}
                      </>
                    )})}
                </tbody>
              </Table>
            </Row>
          </>
        )}
        {pi_info && (
        <Row className='d-flex justify-content-center mt-3'>
          <Col md='auto'>
            <p>Note: </p>
          </Col>
            <textarea rows='3' style={{width:'500px'}} value={pi_info.Note ? pi_info.Note : ''} onChange={handleNoteChange}/>
        </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// VAT of a bill from its line values (each already rounded to 2) - same rule as the server (billVatTotals).
//   VAT only: 15% is added on top of the lines.
//   VAT + "price includes VAT": the line values already include the 15%, so each line's net is value / 1.15
//   rounded to 2, VAT is what is left and the grand total is the sum of the lines.
const billLineNet = (value, inclusive) => (inclusive ? Number((Number(value) / 1.15).toFixed(2)) : Number(value));
const billVatTotals = (lineValues, hasVat, inclusive) => {
  const r2 = (n) => Number(Number(n).toFixed(2));
  const gross = r2(lineValues.reduce((s, v) => s + Number(v), 0));
  if (!hasVat) return { net: gross, vat: 0, total: gross };
  if (inclusive) {
    const net = r2(lineValues.reduce((s, v) => s + billLineNet(v, true), 0));
    return { net, vat: r2(gross - net), total: gross };
  }
  const vat = r2(gross * 0.15);
  return { net: gross, vat, total: r2(gross + vat) };
};

const Edit_Bill_Modal = ({ show, setShow, bill_id, onSaved }) => {
  const [bill_info, set_bill_info] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  // Split into a VAT bill + a cash bill (Panda): VAT bill rate per line, keyed by BillListId, and the cash bill's number.
  const [split, setSplit] = useState(null); // null = not splitting, else { cashNo, rates: { [BillListId]: rate } }

  useEffect(() => {
    if (show && bill_id) {
      set_bill_info(null);
      setError('');
      setSplit(null);
      axios.get(`${window.backendUrl}/get_bill_for_edit/${bill_id}`)
        .then((response) => set_bill_info(response.data))
        .catch((err) => {
          console.log(err);
          setError('Could not load the bill.');
        });
    }
  }, [show, bill_id]);

  // Same formula as Manage Orders / Bill List: each line rounded to 2 decimals.
  const lineAmount = (l) => {
    const qty = Number(l.Quantity) || 0;
    const unit = Number(l.UnitPrice) || 0;
    const addi = Number(l.AddiPrice) || 0;
    const sqm = Number(l.SquareMeter) || 0;
    const rate = l.UnitPricePer === 'Square Meter' ? sqm * unit + addi : l.UnitPricePer === 'Order Qty' ? unit + addi : 0;
    return Number((rate * qty).toFixed(2));
  };

  const handleLineChange = (index, field, value) => {
    const updated = bill_info.bill_lists.map((l, i) => (i === index ? { ...l, [field]: value } : l));
    set_bill_info({ ...bill_info, bill_lists: updated });
  };

  const handleSave = () => {
    const lines = bill_info.bill_lists;
    if (!String(bill_info.BillNo || '').trim()) {
      setError('Bill number is required.');
      return;
    }
    for (const l of lines) {
      const q = Number(l.Quantity);
      if (!Number.isInteger(q) || q < 0 || !(Number(l.UnitPrice) >= 0) || !(Number(l.AddiPrice || 0) >= 0)) {
        setError('Quantity must be a whole number and prices must be numbers, none negative.');
        return;
      }
    }
    setSaving(true);
    setError('');
    axios.post(`${window.backendUrl}/update_bill_info`, {
      BillId: bill_info.BillId,
      BillNo: bill_info.BillNo,
      HasVat: bill_info.HasVat,
      VatInclusive: bill_info.HasVat && bill_info.VatInclusive,
      VatChallanNo: bill_info.VatChallanNo,
      ...(bill_info.ExtrasReady ? {
        ExchangeRate: bill_info.Currency === '$' && String(bill_info.ExchangeRate ?? '').trim() !== '' ? Number(bill_info.ExchangeRate) : null,
        BillToPartyId: bill_info.BillToPartyId ? Number(bill_info.BillToPartyId) : null,
      } : {}),
      bill_lists: lines.map((l) => ({
        BillListId: l.BillListId,
        DeliveryChallanListId: l.DeliveryChallanListId,
        Quantity: Number(l.Quantity),
        UnitPrice: Number(l.UnitPrice),
        AddiPrice: Number(l.AddiPrice || 0),
      })),
    })
      .then(() => {
        setSaving(false);
        setShow(false);
        if (onSaved) onSaved();
      })
      .catch((err) => {
        console.log(err);
        setSaving(false);
        setError('Could not save the bill.');
      });
  };

  // The line's price per piece (as on the bill), and the VAT bill's usual rate: Tk 45 a carton, Tk 11 a box.
  const piecePrice = (l) => {
    const unit = Number(l.UnitPrice) || 0, addi = Number(l.AddiPrice) || 0, sqm = Number(l.SquareMeter) || 0;
    return l.UnitPricePer === 'Square Meter' ? sqm * unit + addi : l.UnitPricePer === 'Order Qty' ? unit + addi : 0;
  };
  const defaultVatRate = (l) => (/carton/i.test(l.ItemName || '') ? 45 : 11);
  const startSplit = () => setSplit({
    cashNo: '',
    rates: Object.fromEntries((bill_info.bill_lists || []).filter((l) => l.BillListId).map((l) => [l.BillListId, Math.min(defaultVatRate(l), piecePrice(l))])),
  });
  const handleSplit = () => {
    if (!String(split.cashNo || '').trim()) { setError('Enter the cash bill number.'); return; }
    if ((bill_info.bill_lists || []).some((l) => !l.BillListId)) { setError('Save the bill once first, then split it.'); return; }
    setSaving(true);
    setError('');
    axios.post(`${window.backendUrl}/split_bill_vat_cash`, {
      BillId: bill_info.BillId,
      CashBillNo: split.cashNo,
      lines: bill_info.bill_lists.map((l) => ({ BillListId: l.BillListId, VatRate: split.rates[l.BillListId] })),
    })
      .then(() => { setSaving(false); setShow(false); if (onSaved) onSaved(); })
      .catch((err) => { setSaving(false); setError(err?.response?.data || 'Could not split the bill.'); });
  };

  const lines = bill_info ? bill_info.bill_lists : [];
  const subtotal = lines.reduce((acc, l) => acc + lineAmount(l), 0);
  const totalQuantity = lines.reduce((acc, l) => acc + (Number(l.Quantity) || 0), 0);
  const vatInclusive = !!(bill_info && bill_info.HasVat && bill_info.VatInclusive);
  const money = (n) => Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // Bills of USD orders are priced in $; with an exchange rate the totals (and VAT) are worked out in Taka,
  // each line converted and rounded to 2, the same as the bill PDF and the Tally voucher.
  const usd = !!bill_info && bill_info.Currency === '$';
  const sym = usd ? '$' : '৳';
  const exRate = usd && Number(bill_info.ExchangeRate) > 0 ? Number(bill_info.ExchangeRate) : null;
  const toTaka = (v) => Number((v * exRate).toFixed(2));
  const vatTotals = billVatTotals(lines.map((l) => (exRate ? toTaka(lineAmount(l)) : lineAmount(l))), bill_info && bill_info.HasVat, vatInclusive);
  const totalSym = exRate ? '৳' : sym;

  return (
    <Modal show={show} onHide={() => setShow(false)} centered className='custom-modal' scrollable size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Change Bill Information</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{fontSize:'16px',padding:'30px 40px'}}>
        {error && <p style={{color:'red'}}>{error}</p>}
        {bill_info && (
          <>
            <Row className="d-flex justify-content-between mb-3 mt-2">
              <Col className='d-flex'>
                <div className='me-4'>
                  <p><strong>Party Name</strong></p>
                  <p><strong>Buyer Name</strong></p>
                </div>
                <div className='me-4'>
                  <p>:</p>
                  <p>:</p>
                </div>
                <div>
                  <p>{bill_info.PartyName}</p>
                  <p>{bill_info.BuyerName}</p>
                </div>
              </Col>
              <Col className='d-flex justify-content-end'>
                <div className='me-4'>
                  <p style={{marginTop:'6px'}}><strong>Bill No.</strong></p>
                  <p><strong>Date</strong></p>
                </div>
                <div className='me-4'>
                  <p style={{marginTop:'6px'}}>:</p>
                  <p>:</p>
                </div>
                <div>
                  <input
                    type="text"
                    style={{ width: '260px', marginBottom: '12px' }}
                    value={bill_info.BillNo || ''}
                    onChange={(e) => set_bill_info({ ...bill_info, BillNo: e.target.value })}
                  />
                  <p>{new Date(bill_info.BillDate * 1000).toLocaleDateString('en-US', { timeZone: 'Asia/Dhaka', year: '2-digit', month: '2-digit', day: '2-digit' }).replace(/\//g, '.')}</p>
                </div>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md='auto'>
                <Form.Check
                  type="checkbox"
                  id="bill-vat-check"
                  label={<strong>15% VAT</strong>}
                  checked={!!bill_info.HasVat}
                  onChange={(e) => set_bill_info({ ...bill_info, HasVat: e.target.checked })}
                />
              </Col>
              {bill_info.HasVat && (
                <Col md='auto'>
                  <Form.Check
                    type="checkbox"
                    id="bill-vat-inclusive-check"
                    label={<strong>Price includes VAT</strong>}
                    title="Tick when the unit prices already include the 15% VAT (e.g. 84.90 = 73.83 + 15%)"
                    checked={!!bill_info.VatInclusive}
                    onChange={(e) => set_bill_info({ ...bill_info, VatInclusive: e.target.checked })}
                  />
                </Col>
              )}
              {bill_info.HasVat && (
                <Col md='auto' className='d-flex align-items-center'>
                  <span className='me-2'>VAT Challan No.:</span>
                  <input
                    type="text"
                    style={{ width: '200px' }}
                    value={bill_info.VatChallanNo || ''}
                    onChange={(e) => set_bill_info({ ...bill_info, VatChallanNo: e.target.value })}
                  />
                </Col>
              )}
            </Row>
            {bill_info.ExtrasReady && (
              <Row className="mb-3 align-items-center">
                <Col md='auto' className='d-flex align-items-center'>
                  <span className='me-2' title="Bill another company than the order's party (e.g. goods delivered to and paid by another concern)"><strong>Bill to:</strong></span>
                  <Form.Select
                    style={{ width: '360px' }}
                    value={bill_info.BillToPartyId || ''}
                    onChange={(e) => set_bill_info({ ...bill_info, BillToPartyId: e.target.value ? Number(e.target.value) : null })}
                  >
                    <option value=''>Same as the order's party ({bill_info.PartyName})</option>
                    {(bill_info.Parties || []).map((p) => (
                      <option key={p.PartyID} value={p.PartyID}>{p.PartyName}{p.TeamName ? ` (${p.TeamName})` : ''}</option>
                    ))}
                  </Form.Select>
                </Col>
                {usd && (
                  <Col md='auto' className='d-flex align-items-center'>
                    <span className='me-2'><strong>Exchange rate (Tk per $):</strong></span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      style={{ width: '120px' }}
                      placeholder="e.g. 122.50"
                      value={bill_info.ExchangeRate ?? ''}
                      onChange={(e) => set_bill_info({ ...bill_info, ExchangeRate: e.target.value })}
                    />
                    {!exRate && <span className='ms-2' style={{ color: '#b45309' }}>Needed before this bill can go to Tally</span>}
                  </Col>
                )}
              </Row>
            )}
            {/* VAT bill + cash bill (Panda): same challans and quantities, the VAT bill at a fixed rate + 15% VAT,
                the cash bill for the rest of the price without VAT. */}
            {bill_info.CashReady && bill_info.CashOfBillId && (
              <p style={{ background: '#fff6dc', padding: '8px 12px' }}>This is the <strong>cash bill</strong> of a VAT bill (same challans). Delete it to put its amounts back on the VAT bill.</p>
            )}
            {bill_info.CashReady && bill_info.CashBill && (
              <p style={{ background: '#fff6dc', padding: '8px 12px' }}>This VAT bill has a <strong>cash bill: {bill_info.CashBill.BillNo}</strong>. Delete the cash bill to undo the split.</p>
            )}
            {bill_info.CashReady && !bill_info.CashOfBillId && !bill_info.CashBill && !split && (
              <Row className="mb-3">
                <Col md='auto'>
                  <Button variant="outline-primary" size="sm" onClick={startSplit} title="Panda: VAT bill at a fixed rate (Tk 11 a box, Tk 45 a carton) + 15% VAT, and a cash bill for the rest">
                    Split into VAT bill + Cash bill
                  </Button>
                </Col>
              </Row>
            )}
            {split && (
              <div style={{ border: '1px solid #b6c8d8', borderRadius: 6, padding: '12px 16px', marginBottom: 16, background: '#f5f9fc' }}>
                <p className='mb-2'><strong>Split into VAT bill + Cash bill</strong> - same challans and quantities. This bill becomes the VAT bill
                  (VAT bill rate + 15% VAT); a new cash bill gets the rest of each price, without VAT. Save other changes first.</p>
                <div className='d-flex align-items-center mb-2'>
                  <span className='me-2'><strong>Cash bill number:</strong></span>
                  <input type="text" style={{ width: '260px' }} value={split.cashNo} onChange={(e) => setSplit({ ...split, cashNo: e.target.value })} />
                </div>
                <Table size="sm" bordered>
                  <thead><tr><th>Item</th><th>Quantity</th><th>Price per piece</th><th>VAT bill rate</th><th>Cash bill rate</th><th>VAT bill (+15%)</th><th>Cash bill</th></tr></thead>
                  <tbody>
                    {lines.filter((l) => l.BillListId).map((l) => {
                      const price = Number(piecePrice(l).toFixed(4));
                      const v = Number(split.rates[l.BillListId]);
                      const c = Number((price - (v || 0)).toFixed(4));
                      const qty = Number(l.Quantity) || 0;
                      return (
                        <tr key={l.BillListId} style={c < 0 ? { color: 'red' } : undefined}>
                          <td>{l.ItemName}</td><td>{qty}</td><td>{sym}{money(price)}</td>
                          <td><input type="number" step="0.01" min="0" style={{ width: '90px' }} value={split.rates[l.BillListId] ?? ''}
                            onChange={(e) => setSplit({ ...split, rates: { ...split.rates, [l.BillListId]: e.target.value } })} /></td>
                          <td>{sym}{money(c)}</td>
                          <td>{sym}{money(Number((qty * (v || 0) * 1.15).toFixed(2)))}</td>
                          <td>{sym}{money(Number((qty * c).toFixed(2)))}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <Button variant="primary" size="sm" className='me-2' onClick={handleSplit} disabled={saving}>{saving ? 'Splitting...' : 'Split'}</Button>
                <Button variant="secondary" size="sm" onClick={() => setSplit(null)} disabled={saving}>Cancel</Button>
              </div>
            )}
            <Row>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Item Name</th>
                    <th>Spec.</th>
                    <th>Measurement</th>
                    <th>Quantity</th>
                    <th>Sq. Mt.</th>
                    <th>Unit Price <br/> ({sym})</th>
                    <th>Addi Work <br/> Price ({sym})</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {lines.map((item, index) => (
                    <React.Fragment key={item.DeliveryChallanListId}>
                      {(index === 0 || lines[index - 1].DeliveryChallanId !== item.DeliveryChallanId) && (
                        <tr>
                          <td colSpan='9' style={{ background: '#e9ecef' }}>
                            <strong>Challan {item.DeliveryChallanNo}</strong> &nbsp; Job: {item.JobNumber}{item.Style ? ` · Style: ${item.Style}` : ''}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.ItemName}</td>
                        <td>{item.Specification}</td>
                        <td>{item.Measurement}</td>
                        <td>
                          <input
                            type="number"
                            style={{ width: '90px' }}
                            value={item.Quantity}
                            onChange={(e) => handleLineChange(index, 'Quantity', e.target.value)}
                          />
                        </td>
                        <td>{item.UnitPricePer === 'Square Meter' ? item.SquareMeter : ''}</td>
                        <td>
                          <input
                            type="number"
                            style={{ width: '90px' }}
                            value={item.UnitPrice}
                            onChange={(e) => handleLineChange(index, 'UnitPrice', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            style={{ width: '90px' }}
                            value={item.AddiPrice}
                            onChange={(e) => handleLineChange(index, 'AddiPrice', e.target.value)}
                          />
                        </td>
                        <td>{sym}{money(lineAmount(item))}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                  <tr>
                    <td colSpan='4' style={{textAlign:'right'}}><strong>Total :</strong></td>
                    <td><strong>{totalQuantity}</strong></td>
                    <td colSpan='3'></td>
                    <td><strong>{sym}{money(subtotal)}</strong></td>
                  </tr>
                  {exRate && (
                    <tr>
                      <td colSpan='8' style={{textAlign:'right'}}><strong>In Taka (@ Tk {exRate} per $) :</strong></td>
                      <td><strong>৳{money(billVatTotals(lines.map((l) => toTaka(lineAmount(l))), false, false).total)}</strong></td>
                    </tr>
                  )}
                  {bill_info.HasVat && (
                    <>
                      {vatInclusive && (
                        <tr>
                          <td colSpan='8' style={{textAlign:'right'}}><strong>Amount without VAT :</strong></td>
                          <td><strong>{totalSym}{money(vatTotals.net)}</strong></td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan='8' style={{textAlign:'right'}}><strong>VAT 15%{vatInclusive ? ' (included)' : ''} :</strong></td>
                        <td><strong>{totalSym}{money(vatTotals.vat)}</strong></td>
                      </tr>
                      <tr>
                        <td colSpan='8' style={{textAlign:'right'}}><strong>Grand Total :</strong></td>
                        <td><strong>{totalSym}{money(vatTotals.total)}</strong></td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={saving || !bill_info}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const New_Group_Pi_Modal = ({ show, setShow, handleSave}) => {
  
  const [group_pi_no, set_group_pi_no] = useState('');
  const [party_address, set_party_address] = useState('');

  const onSave = () => {
    handleSave({group_pi_no, party_address});
    setShow(false);
  };

  useEffect(() => {
      set_group_pi_no('');
      set_party_address('');
  }, [show]);

  // console.log(number)
  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Group Pi</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <Row >
          <Col className='d-flex-col me-2'>
              <h5 style={{textAlign:'right', marginBottom:'40px', fontWeight:'bold'}}>Group PI No. : </h5>
              <h5 style={{textAlign:'right', marginBottom:'20px', fontWeight:'bold'}}>Party Address : </h5>
          </Col>
          <Col className='d-flex-col'>
              <Form.Control type="text" value={group_pi_no} onChange={(e) => set_group_pi_no(e.target.value)} style={{width:'300px',marginBottom:'30px'}}/>
              <textarea rows='4' value={party_address} onChange={(e) => set_party_address(e.target.value)} style={{width:'300px',marginBottom:'20px'}}/>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Remove_Group_Pi_Modal = ({ show, setShow, handleRemove, groupPi }) => {

  const onRemove = () => {
      handleRemove(groupPi.GroupPiId);
      setShow(false);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title><strong>Remove Group PI</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <h5>Are you sure you want to remove {groupPi.GroupPiNo} of {groupPi?.PIs?.[0]?.PartyName} ?</h5>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="danger" onClick={onRemove}>
          Remove
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Edit a Group PI's jobs: untick a job to take it out, tick one of the party's other
// approved jobs (not in any group yet) to add it.
const Edit_Group_Pi_Modal = ({ show, setShow, group_pi_id, onSaved }) => {
  const [info, setInfo] = useState(null);
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show && group_pi_id) {
      setInfo(null);
      setRows([]);
      setSearch('');
      setError('');
      axios.get(`${window.backendUrl}/get_group_pi_info/${group_pi_id}`)
        .then((response) => {
          const inGroup = response.data.group_pi_list;
          setInfo(response.data.group_pi_info);
          setRows([...inGroup, ...response.data.available_pi_list]);
          setSelected(inGroup.map((r) => r.OrderId));
        })
        .catch((err) => {
          console.log(err);
          setError('Could not load the group PI.');
        });
    }
  }, [show, group_pi_id]);

  const toggle = (orderId) => {
    setSelected((prev) => (prev.includes(orderId) ? prev.filter((id) => id !== orderId) : [...prev, orderId]));
  };

  const handleSave = () => {
    if (!selected.length) {
      setError('Keep at least one job. To delete the whole group PI, use the trash icon.');
      return;
    }
    setSaving(true);
    setError('');
    axios.post(`${window.backendUrl}/update_group_pi`, { group_pi_id, order_ids: selected })
      .then(() => {
        setSaving(false);
        setShow(false);
        if (onSaved) onSaved();
      })
      .catch((err) => {
        console.log(err);
        setSaving(false);
        setError(err?.response?.data?.error || 'Could not save the group PI.');
      });
  };

  const formatDate = (unix) => new Date(unix * 1000).toLocaleDateString('en-GB', { timeZone: 'Asia/Dhaka', day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '.');
  const term = search.trim().toLowerCase();
  const matches = (r) => !term || [r.JobNumber, r.Style, r.LpdPoNo, r.BuyerName].some((v) => String(v || '').toLowerCase().includes(term));
  const inGroup = rows.filter((r) => selected.includes(r.OrderId));
  const notInGroup = rows.filter((r) => !selected.includes(r.OrderId) && matches(r));
  const total = inGroup.reduce((acc, r) => acc + (Number(r.TotalPrice) || 0), 0);

  const renderRows = (list, checked) => list.map((r) => (
    <tr key={r.OrderId} onClick={() => toggle(r.OrderId)} style={{ cursor: 'pointer' }}>
      <td><input type="checkbox" checked={checked} readOnly /></td>
      <td>{r.JobNumber}</td>
      <td>PI/{r.JobNumber}<br />{formatDate(r.PiDate)}</td>
      <td>{r.Style}<br />{r.LpdPoNo}</td>
      <td>{r.BuyerName}</td>
      <td style={{ textAlign: 'right' }}>${(Number(r.TotalPrice) || 0).toFixed(2)}</td>
    </tr>
  ));

  const header = (
    <thead>
      <tr>
        <th></th>
        <th>Job No</th>
        <th>PI No / Date</th>
        <th>Style / LPD PO No</th>
        <th>Buyer Name</th>
        <th>Total Price</th>
      </tr>
    </thead>
  );

  return (
    <Modal show={show} onHide={() => setShow(false)} centered className='custom-modal' scrollable size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Edit Group PI Jobs</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: '15px', padding: '20px 30px' }}>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {info && (
          <>
            <p className='mb-1'><strong>Group PI No. :</strong> {info.GroupPiNo}</p>
            <p className='mb-3'><strong>Party Name :</strong> {info.PartyName}</p>

            <h6><strong>Jobs in this Group PI ({inGroup.length})</strong> <span className='text-muted' style={{ fontWeight: 'normal' }}>(untick to remove)</span></h6>
            <Table bordered size='sm' style={{ fontSize: '13px' }}>
              {header}
              <tbody>
                {renderRows(inGroup, true)}
                <tr className='green_row'>
                  <td colSpan='5' style={{ textAlign: 'right' }}><strong>Grand Total:</strong></td>
                  <td style={{ textAlign: 'right' }}><strong>${total.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </Table>

            <div className='d-flex align-items-center justify-content-between mt-4 mb-2'>
              <h6 className='mb-0'><strong>Add jobs</strong> <span className='text-muted' style={{ fontWeight: 'normal' }}>(approved PIs of this party not in any group PI)</span></h6>
              <Form.Control type='text' placeholder='Search job / style / buyer' value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: '250px' }} />
            </div>
            <Table bordered size='sm' style={{ fontSize: '13px' }}>
              {header}
              <tbody>
                {notInGroup.length ? renderRows(notInGroup, false) : (
                  <tr><td colSpan='6' className='text-center text-muted'>No other jobs available</td></tr>
                )}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={!info || saving}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const PPExcelDateModal = ({ show, handleClose, handleSave }) => {
  const [date, setDate] = useState('');

  useEffect(() => {
    setDate('');
  },[]);

  const onChoose = () => {
    const pp_date_unix = Math.floor(new Date(date).getTime() / 1000);
    handleSave(pp_date_unix);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Choose P.P Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="scheduleDate">
            <Form.Label> <h6>Select a date:</h6></Form.Label>
            <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onChoose}>
          Download
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const convertNumberToWords = (amount) => {
  const units = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 
      'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 
      'Ninety'
  ];
  const thousands = ['', 'Thousand'];

  const getWords = (num) => {
      if (num === 0) return 'Zero';
      
      let words = '';
      
      if (num >= 1000) {
          words += getWords(Math.floor(num / 1000)) + ' ' + thousands[1] + ' ';
          num %= 1000;
      }
      
      if (num >= 100) {
          words += getWords(Math.floor(num / 100)) + ' Hundred ';
          num %= 100;
      }
      
      if (num >= 20) {
          words += tens[Math.floor(num / 10)] + ' ';
          num %= 10;
      }
      
      if (num > 0) {
          words += units[num] + ' ';
      }
      
      return words.trim();
  };
  
  const dollars = Math.floor(amount);
  const cents = Math.round((amount - dollars) * 100);

  const dollarWords = getWords(dollars);
  const centWords = getWords(cents);

  return `${dollarWords} Dollars${cents > 0 ? ' & ' + centWords + ' Cents' : ''}`;
};

const convertNumberToWordsTaka = (amount) => {
  const units = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 
      'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 
      'Ninety'
  ];
  const thousands = ['', 'Thousand'];

  const getWords = (num) => {
      if (num === 0) return 'Zero';
      
      let words = '';
      
      if (num >= 1000) {
          words += getWords(Math.floor(num / 1000)) + ' ' + thousands[1] + ' ';
          num %= 1000;
      }
      
      if (num >= 100) {
          words += getWords(Math.floor(num / 100)) + ' Hundred ';
          num %= 100;
      }
      
      if (num >= 20) {
          words += tens[Math.floor(num / 10)] + ' ';
          num %= 10;
      }
      
      if (num > 0) {
          words += units[num] + ' ';
      }
      
      return words.trim();
  };
  
  const dollars = Math.floor(amount);
  const cents = Math.round((amount - dollars) * 100);

  const dollarWords = getWords(dollars);
  const centWords = getWords(cents);

  return `${dollarWords} Taka${cents > 0 ? ' & ' + centWords + ' Paisa' : ''}`;
};

// function formatNumberWithCommas(number) {
//   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// }
function formatNumberWithCommas(number) {
  // Split the number into the integer and decimal parts
  const [integerPart, decimalPart] = number.toString().split('.');

  // Format the integer part with commas for crores, lakhs, and thousands
  const lastThreeDigits = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);
  const formattedInteger = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (otherDigits ? ',' : '') + lastThreeDigits;

  // Combine the formatted integer part with the decimal part if it exists
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}


function getAbbreviationForPi(name) {
  const words = String(name || '').split(' ').filter(word => word.length > 0); // Split and filter out empty strings
  const abbreviation = words.slice(0, 3) // Take the first 3 words
      // First letter of each word; a bracketed word like "(BD)" gives B, not "(" (existing PI numbers stay the same)
      .map(word => (word.charAt(0) === '(' && word.length > 1 ? word.charAt(1) : word.charAt(0)))
      .join(''); // Join them together
  return abbreviation;
}

export {handlePagination, renderPagination,renderTableData, renderTableData2, PartyTable, 
        renderAdvancedPagination, JobApprovalModal, ScheduleDateModal, Add_BM_Modal, Edit_PP_Qty_Modal, 
        PP_Date_Modal, BM_Small_Trash_Modal, Add_Finishing_Modal, Gate_Pass_Date_Modal,  Gate_Pass_Delete_Modal, Gate_Pass_Status_Modal,
         New_Gate_Pass_Modal, Edit_Pi_Modal, New_Group_Pi_Modal,convertNumberToWords, formatNumberWithCommas, getAbbreviationForPi,
         PPExcelDateModal, Remove_Group_Pi_Modal, Edit_Group_Pi_Modal, Create_Bill_Modal, convertNumberToWordsTaka, Remove_Bill_Modal, Edit_Bill_Modal,
         billLineNet, billVatTotals};
